"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var item_1 = require("common/domain/item");
var React = require("react");
var Save = require("react-icons/lib/md/save");
var react_redux_1 = require("react-redux");
var CircleButton_1 = require("../component/CircleButton");
var ItemList_1 = require("../component/ItemList");
var ItemsMenuButton_1 = require("../component/ItemsMenuButton");
require("./style/Items.css");
var Items = /** @class */ (function (_super) {
    __extends(Items, _super);
    function Items() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { done: false, fixed: false };
        return _this;
    }
    Items.prototype.render = function () {
        var _this = this;
        var _a = this.props, currentItem = _a.currentItem, doneItems = _a.doneItems, isSmallWindow = _a.isSmallWindow, todoItems = _a.todoItems, touchable = _a.touchable, signedIn = _a.signedIn;
        var done = this.state.done;
        var Item = this.props.itemComponent;
        var ItemsMenu = this.props.menuComponent;
        var itemsMenu = (React.createElement(ItemsMenu, { done: done, onItemsStateChange: function (done) { return _this.setState({ done: done }); }, makeItemListSortable: function () { return _this.setState({ fixed: false }); } }));
        var sorting = touchable && !this.state.fixed;
        var itemListProps = __assign({}, this.props, { fixed: this.props.fixed || this.state.fixed, sorting: sorting });
        return (React.createElement("div", { className: "Items-container" },
            React.createElement("div", { className: "Items-content" },
                !isSmallWindow && itemsMenu,
                React.createElement("div", { className: "Items-main" },
                    React.createElement(ItemList_1.default, __assign({ style: done ? { display: "none" } : {}, done: false, items: todoItems }, itemListProps)),
                    React.createElement(ItemList_1.default, __assign({ style: done ? {} : { display: "none" }, done: true, items: doneItems }, itemListProps)),
                    !isSmallWindow &&
                        React.createElement("div", { className: "Items-current-item-container" }, currentItem &&
                            React.createElement(Item, __assign({ detailed: true, done: done }, currentItem))),
                    isSmallWindow &&
                        React.createElement(ItemsMenuButton_1.default, { closed: sorting, hidden: sorting, itemsMenu: itemsMenu }),
                    sorting &&
                        React.createElement("div", { className: "Items-fix-list-button-container" },
                            React.createElement(CircleButton_1.default, { onClick: function () { return _this.setState({ fixed: true }); } },
                                React.createElement(Save, null)))))));
    };
    Items.prototype.componentDidMount = function () {
        if (this.props.touchable) {
            this.setState({ fixed: true });
        }
        this.componentDidUpdate();
    };
    Items.prototype.componentDidUpdate = function () {
        var _a = this.props, currentItem = _a.currentItem, doneItems = _a.doneItems, setCurrentItem = _a.setCurrentItem, todoItems = _a.todoItems;
        var items = this.state.done ? doneItems : todoItems;
        if (currentItem === null && items.length !== 0 ||
            currentItem !== null && !item_1.include(items, currentItem)) {
            setCurrentItem(items[0] || null);
        }
    };
    return Items;
}(React.Component));
exports.default = react_redux_1.connect(function (_a) {
    var authentication = _a.authentication, environment = _a.environment;
    return (__assign({}, authentication, environment));
})(Items);



//////////////////
// WEBPACK FOOTER
// ./src/container/Items.tsx
// module id = 102
// module chunks = 0